module.exports = __webpack_public_path__ + "img/apple_stote.f89c2fd1.png";